export default __webpack_public_path__ + "static/media/ialeap_alt_sf_bl.796103d0.png";